import React from 'react';
import { Table } from 'reactstrap';

import styles from './styles.module.scss';

function PersonalDataTable({ data }) {
  return (
    <>
      <h4 className="mt-0">Datos personales</h4>
      <Table hover>
        <tbody>
          <tr>
            <td className={styles.labelCell}>ID</td>
            <td>{data.id}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Nombre</td>
            <td>{data.data?.firstName || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Apellido</td>
            <td>{data.data?.lastName || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>RUT</td>
            <td>{data.data?.rut || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Teléfono</td>
            <td>{data.data?.phone || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Correo Electrónico</td>
            <td>{data.data?.email || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Dirección</td>
            <td>{data.data?.address || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Región</td>
            <td>{data.data?.region || '--'}</td>
          </tr>
          <tr>
            <td className={styles.labelCell}>Comuna</td>
            <td>{data.data?.commune || '--'}</td>
          </tr>
        </tbody>
      </Table>

      {data.data?.isCompany && (
        <>
          <h4>Datos de la compañia</h4>
          <Table hover>
            <tbody>
              <tr>
                <td className={styles.labelCell}>Nombre</td>
                <td>{data.data?.companyInfo?.name || '--'}</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>RUT</td>
                <td>{data.data?.companyInfo?.rut || '--'}</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Dirección</td>
                <td>{data.data?.companyInfo?.address || '--'}</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Región</td>
                <td>{data.data?.companyInfo?.region || '--'}</td>
              </tr>
              <tr>
                <td className={styles.labelCell}>Comuna</td>
                <td>{data.data?.companyInfo?.commune || '--'}</td>
              </tr>
            </tbody>
          </Table>
        </>
      )}
    </>
  );
}

export default PersonalDataTable;
